import Carousel from "./Carousel";

function Home() {
    return (
        <div className="Home">
            <h1>Featured Collections</h1>
            <Carousel />
        </div>
    );
}

export default Home;
